const siteConfig = {
  name: "",
  url: "",
  ogImage: "",
  description: "",
  links: {
    socialMedia: {
      facebook: "https://www.facebook.com/hotelshippocom",
      instagram: "https://www.instagram.com/hotelshippocom",
      linkedin: "https://www.linkedin.com/company/hotels-hippo-com-pvt-ltd",
      pinterest: "https://www.pinterest.com/hotelshippocom",
      twitter: "https://twitter.com/hotelshippocom",
      youtube: "https://www.youtube.com/@hotelshippocom",
    },
    services: {
      hotelsHippo: "https://www.hotelshippo.com",
      hippoCorporate: "https://www.hotelshippo.com",
      wellnessCeylon: "https://wellnessceylon.co.uk",
    },
    usefulLinks: {
      whoWeAre: "/about-us",
      news: "/news",
      careers: "/careers",
      blog: "https://blog.hotelshippo.com",
      siteMap: "/sitemap",
      partnerPortal: "https://partner.hotelshippo.com",
      faq: "/faq",
      usePolicy: "/acceptable-use-policy",
      DSARForm: "/privacy/dsar-form",
      doNotSellMyInfo: "/privacy/do-not-sell",
      bookingTerms: "/booking-terms",
      privacyPolicy: "/privacy-policy",
      helpAndSupport: "https://support.hotelshippo.com",
      terms: "/terms-and-conditions",
      cookiePolicy: "/cookie-policy",
      manageCookie: "/manage-cookies",
      disclaimer: "/disclaimer",
      listYourProperty: "https://partner.hotelshippo.com/sign-up",
    },
  },
};

export default siteConfig;
